export default class UtilObject{

    static isEmpty = (object) => {
        return (
            object &&
            Object.keys(object).length === 0 &&
            object.constructor === Object
        );
    }

    static merge = (target = {}, source = {}) => {
        return this.shallowMerge(target, source);
    };

    static shallowMerge = (target = {}, source = {}) => {
        return {...target, ...source};
    }

    static deepMerge = (target, source) => {

        // Itera pelas propriedades do objeto source
        for (let key in source) {

            if (Object.prototype.hasOwnProperty.call(source, key)) {

                // Se a propriedade for um objeto e ambos (target e source) a tiverem como objeto
                if (source[key] && typeof source[key] === 'object' && target[key] && typeof target[key] === 'object') {

                    // Realiza a mesclagem recursiva dos objetos
                    this.deepMerge(target[key], source[key]);

                } else {

                    // Caso contrário, apenas atribui o valor da propriedade do source ao target
                    target[key] = source[key];

                }       

            }

        }

        return target;
    }

    static clone = (target = {}) => {
        return this.shallowClone(target);
    };

    static shallowClone = (target = {}) => {
        return {...target};
    };

    /**
     * Resolve o valor de uma propriedade aninhada em um objeto
     * usando uma string com notação de ponto como caminho.
     *
     * @param {Object} obj     - Objeto de origem
     * @param {string} caminho - Caminho da propriedade (ex: 'emitente.nome')
     * @returns {*} Valor encontrado ou `undefined` se o caminho não existir
     *
     * @example
     * resolveByPath({ emitente: { nome: 'João' } }, 'emitente.nome') // → 'João'
     * resolveByPath({ codigo: 42 }, 'codigo')                        // → 42
     * resolveByPath({ emitente: null }, 'emitente.nome')             // → undefined
     */
    static resolveByPath = (obj = {}, caminho = '') => {

        if(!caminho){
            return undefined;
        }

        let atual = obj;

        for(const chave of caminho.split('.')){
            atual = atual?.[chave];
        }

        return atual;

    };

}